export default __webpack_public_path__ + "locales/uk-UA/BackupCodesDialog.json?hash=808c3a6c60a63e7acb9e1735391fd07c";